export default __webpack_public_path__ + "static/media/fi.91593c2e.gif";